var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pub-info-title",class:{
    'modal-info-title-bg': _vm.isModal,
    'modal-info-title-long-bg': _vm.isModalLong
  }},[_c('img',{staticClass:"arrow-img",attrs:{"src":require("@/assets/images/apng/infoTitleArrow.png"),"alt":""}}),_c('p',{staticClass:"title-font"},[_vm._v(_vm._s(_vm.title))]),_c('img',{staticClass:"rect-img",attrs:{"src":require("@/assets/images/apng/infoTitleRect.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }